export const TOOLTIP_TEXT = "Some employers might require you to complete an extra step as part of your application";
export const APPLICATION_PROCESS_STEPS = [
    { _id: 1, text: 'Profile vetted', propertyName: 'isProfileVettedStepFinished' },
    { _id: 2, text: 'Search for Jobs', propertyName: 'isSearchForJobStepFinished' },
    { _id: 3, text: 'Send your application', propertyName: 'isSearchForJobStepFinished' },
    { _id: 4, text: 'Interview with client', propertyName: 'isInterviewStepFinished' },
    { _id: 5, text: 'Project onboarding', propertyName: 'isProjectOnboardingStepFinished' },
];
